
<table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

    <ng-container matColumnDef="programa_projeto">
        <th mat-header-cell *matHeaderCellDef style="width: 60%"> Programa/Projeto </th>
        <td mat-cell *matCellDef="let element"> {{element.programa?.nome || element.projeto?.nome}}</td>
    </ng-container>

    <ng-container matColumnDef="dataInicio">
        <th mat-header-cell *matHeaderCellDef> Data início </th>
        <td mat-cell *matCellDef="let element"> {{element.dataInicioVinculacao | dataSimples}} </td>
    </ng-container>

    <ng-container matColumnDef="dataFim">
        <th mat-header-cell *matHeaderCellDef> Data fim</th>
        <td mat-cell *matCellDef="let element"> {{element.dataFimVinculacao | dataSimples}} </td>
    </ng-container>

    <ng-container matColumnDef="acoes">
        <th mat-header-cell *matHeaderCellDef> Ações </th>
        <td mat-cell *matCellDef="let element">
            <button *ngIf="perfilAcesso.deleta"  mat-button (click)="deletar(element)">
                <mat-icon>delete</mat-icon>
            </button>
            <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                <mat-icon>create</mat-icon>
            </button>
        </td>
    </ng-container>    

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<div [hidden]="!mostrarTabela">
    <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
</div>

<ng-template #tabelaSemDados>
    <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
        {{msg}}
    </div>
</ng-template>

<div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 30px">
    <div>
        <button matTooltip="Adicionar nova alocação" mat-fab color="primary" (click)="novo()">
            <mat-icon>add</mat-icon>
        </button>
    </div>
</div>
